// @flow
import type { FavouritePlace } from 'mz-sdk/api_types'
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

// Types
type Request = {
  id: string,
}

// API Endpoinds
export const USER_FAVOURITE_PLACES_ENDPOINT = '/auth/users/{0}/favorites/{1}'

/**
 * Removes favourite place by id
 * @param {Object} data Data
 * @param {string} data.id Place ID
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const deleteFavouritePlace = (
  data: Request
): Promise<FavouritePlace> => {
  const userId = getAuthorizedUserId()
  const endpoint = format(USER_FAVOURITE_PLACES_ENDPOINT, userId, data.id)

  return client.delete(endpoint)
}

export default deleteFavouritePlace
